module.exports = __webpack_public_path__ + "img/icon_kefu.3da130f2.png";